import { rtkApi } from '@/apis/rtkApi';

export type LoanChecklistMatrixItem = {
  key: string;
  label: string;
  required: boolean;
  requiredForSubmit: boolean;
};

export type LoanChecklistMatrix = {
  _id: string;
  ruleKey: string;
  items: LoanChecklistMatrixItem[];
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
};

type ListResponse = {
  success: boolean;
  data: LoanChecklistMatrix[];
  knownRuleKeys: string[];
};

type MatrixResponse = {
  success: boolean;
  data: LoanChecklistMatrix;
};

export const loanChecklistMatrixApi = rtkApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAdminLoanChecklistMatrices: builder.query<
      { matrices: LoanChecklistMatrix[]; knownRuleKeys: string[] },
      void
    >({
      query: () => ({
        url: '/admin/loan-checklist-matrices',
        method: 'GET',
      }),
      transformResponse: (r: ListResponse) => ({
        matrices: r.data ?? [],
        knownRuleKeys: r.knownRuleKeys ?? [],
      }),
      providesTags: ['LoanChecklistMatrices'],
    }),

    putAdminLoanChecklistMatrix: builder.mutation<
      LoanChecklistMatrix,
      { ruleKey: string; items: LoanChecklistMatrixItem[] }
    >({
      query: ({ ruleKey, items }) => ({
        url: `/admin/loan-checklist-matrices/${encodeURIComponent(ruleKey)}`,
        method: 'PUT',
        data: { items },
      }),
      transformResponse: (r: MatrixResponse) => r.data,
      invalidatesTags: ['LoanChecklistMatrices'],
    }),

    resetAdminLoanChecklistMatrices: builder.mutation<
      LoanChecklistMatrix[],
      void
    >({
      query: () => ({
        url: '/admin/loan-checklist-matrices/reset-defaults',
        method: 'POST',
      }),
      transformResponse: (r: {
        success: boolean;
        data: LoanChecklistMatrix[];
      }) => r.data ?? [],
      invalidatesTags: ['LoanChecklistMatrices'],
    }),
  }),
});

export const {
  useGetAdminLoanChecklistMatricesQuery,
  usePutAdminLoanChecklistMatrixMutation,
  useResetAdminLoanChecklistMatricesMutation,
} = loanChecklistMatrixApi;
